import { Button, ButtonProps } from '@nextui-org/react';
import { FaComments } from 'react-icons/fa6';
import Icon from '../base/Icon';
import { useNavigate } from 'react-router-dom';

export default function SavedChatsButton(props: ButtonProps) {
  const navigate = useNavigate();
  const chatsClickHandler = () => () => {
    navigate('/chats');
  };

  const isActive = window.location.pathname === '/chats';

  return (
    <Button
      onPress={chatsClickHandler()}
      {...props}
      isIconOnly
      className={`${isActive ? 'active-chats-btn' : 'chats-btn'}`}
    >
      <Icon icon={FaComments} />
    </Button>
  );
}
